import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';

import Divider from '@goeuro/app/client/frontend-components/src/Divider';
import {
  H1 as _H1,
  H2 as _H2,
  H3 as _H3,
  H4 as _H4,
  H5 as _H5,
  H6 as _H6,
  ParagraphRegular as _ParagraphRegular,
  ParagraphSmall as _ParagraphSmall,
} from '@goeuro/app/client/frontend-components/src/Typography';

import Link from 'components/shared/link';

// eslint-disable-next-line react/display-name
const withStyle = (Component, style = {}) => ({ color, ...props }) => (
  <Component style={{ color, lineHeight: 'normal', ...style }} {...props} />
);

export const H1 = withStyle(_H1);
export const H2 = withStyle(_H2);
export const H3 = withStyle(_H3);
export const H4 = withStyle(_H4);
export const H5 = withStyle(_H5);
export const H6 = withStyle(_H6);
export const ParagraphSmall = withStyle(_ParagraphSmall);

const StyledParagraph = withStyle(_ParagraphRegular, { lineHeight: '24px' });

const Markdown = ({ children, escapeHtml, color }) => {
  const Paragraph = props => <StyledParagraph color={color} {...props} />;

  const Heading = ({ level, ...props }) => {
    switch (level) {
      case 1:
        return <H1 color={color} {...props} />;
      case 2:
        return <H2 color={color} {...props} />;
      case 3:
        return <H3 color={color} {...props} />;
      case 4:
        return <H4 color={color} {...props} />;
      case 5:
        return <H5 color={color} {...props} />;
      case 6:
        return <H6 color={color} {...props} />;
      default:
        return <StyledParagraph color={color} {...props} />;
    }
  };

  return (
    <ReactMarkdown
      components={{
        p: Paragraph,
        link: Link,
        heading: Heading,
        thematicBreak: Divider,
      }}
    >
      {children}
    </ReactMarkdown>
  );
};
Markdown.propTypes = {
  escapeHtml: PropTypes.bool,
  color: PropTypes.string,
  children: PropTypes.any,
};

export const ParagraphRegular = ({ isMarkdown = true, ...props }) =>
  isMarkdown ? <Markdown {...props} /> : <StyledParagraph {...props} />;

ParagraphRegular.propTypes = {
  isMarkdown: PropTypes.bool,
  escapeHtml: PropTypes.bool,
  color: PropTypes.string,
};
